export const ORG_TYPE_DETAIL_COUNT = {
  CONSULTANT: 2,
  CORPORATION: 4,
  GOVERNMENT: 0,
  NONPROFIT: 0,
  RECRUITER: 1,
  COMMUNITY: 2,
};
